import AdsList from "./AdsList";

export default AdsList;
